import {getField, updateField} from "vuex-map-fields"

let filters = {
    assigned_agents : null,
    created : null,
    date : null,  // Due date (to match filter drawer)
    due_date : null,  // Keep for backwards compatibility
    completed_date : null,
    activity : [],
    dispo : [],
    status : null,
    sort : 'date ASC',
    include_hidden : 'no',
    task_call_done : [],  // Automated call status
    source : []  // Task source filter
}

let tempFilters = {
    assigned_agents : null,
    created : null,
    date : null,  // Due date (to match filter drawer) 
    due_date : null,  // Keep for backwards compatibility
    completed_date : null,
    activity : [],
    dispo : [],
    status : null,
    sort : 'date ASC',
    include_hidden : 'no',
    task_call_done : [],  // Automated call status
    source : []  // Task source filter
}

let tempFilterShow = -1

export const state = () => ({
    filters: filters,
    tempFilters : tempFilters,
    tempFilterShow: tempFilterShow,
    showFilters: false,
})


export const getters = {
    getField,
}

export const mutations = {
    updateField,
    resetFilter(state) {
        // Create fresh copies to avoid reference issues
        state.filters = {
            assigned_agents : null,
            created : null,
            date : null,
            due_date : null,
            completed_date : null,
            activity : [],
            dispo : [],
            status : null,
            sort : 'date ASC',
            include_hidden : 'no',
            task_call_done : [],
            source : []
        }
        state.tempFilters = {
            assigned_agents : null,
            created : null,
            date : null,
            due_date : null,
            completed_date : null,
            activity : [],
            dispo : [],
            status : null,
            sort : 'date ASC',
            include_hidden : 'no',
            task_call_done : [],
            source : []
        }
        state.tempFilterShow = -1
    },
    toggleFilter(state) {
        state.showFilters = !state.showFilters
    }
}
